import type { FrameTransaction } from "@moonpay/platform-protocol/models/transaction";
import { track } from "@connect/observability";
import type { PostMessageClient } from "@connect/post-message/client";
import type { ChallengeMessageMap } from "@connect/post-message/protocol";
import { flushTerminal } from "../../../../lib/flush-terminal.ts";
import { trackFrameReady } from "../../../../lib/track-frame-ready.ts";
import type { MessageMeta } from "../../../../lib/external-messages.types.ts";

const FLOW = "buy" as const;

export function createExternalMessages(send: PostMessageClient<ChallengeMessageMap>["send"]) {
  const fail = async (payload: ChallengeMessageMap["error"], meta: MessageMeta) => {
    track.info("connect.challenge.failed", { flow: FLOW, code: payload.code, ...meta });
    await flushTerminal();
    send("error", payload);
  };

  return {
    ready() {
      track.info("connect.challenge.ready", { flow: FLOW });
      trackFrameReady(FLOW);
      send("ready");
    },

    async complete(transaction: FrameTransaction, sessionUpgraded?: boolean) {
      track.info("connect.challenge.succeeded", { flow: FLOW, status: transaction.status });
      await flushTerminal();
      send("complete", { flow: FLOW, transaction, ...(sessionUpgraded && { sessionUpgraded }) });
    },

    async resolved() {
      track.info("connect.challenge.resolved", { flow: FLOW });
      await flushTerminal();
      send("resolved", { flow: FLOW });
    },

    async cancelled(resume?: { challengeToken?: string; transactionId?: string }) {
      track.info("connect.challenge.cancelled", { flow: FLOW });
      await flushTerminal();
      send("cancelled", { flow: FLOW, ...resume });
    },

    error(payload: ChallengeMessageMap["error"], meta: MessageMeta = {}) {
      return fail(payload, meta);
    },
  };
}
